<template>
    <v-container style="padding: 16px">
        <v-card
            v-for="response in ticketDetailResponses"
            :key="response.id"
            class="responses-container mb-4"
            max-width="100%"
            outlined
        >
            <v-row class="mx-2 mb-2 d-flex flex-column">
                <div class="custom-header">
                    <div>
                        <div class="response-square" />
                        <span>{{ response.member_code }}</span>
                    </div>
                    <div v-if="!$vuetify.breakpoint.xs">
                        <v-btn
                            class="ma-1 text-subtitle-2"
                            outlined
                            light
                            @click="respond(response)"
                        >
                            <v-icon
                                left
                                class="action-icon"
                            >
                                reply
                            </v-icon>
                            Respond
                        </v-btn>
                        <v-btn
                            v-if="online"
                            class="ma-1 text-subtitle-2"
                            outlined
                            light
                            @click="assign(response)"
                        >
                            <v-icon
                                left
                                dark
                                class="material-icons-outlined action-icon"
                            >
                                assignment_turned_in
                            </v-icon>
                            Assign
                        </v-btn>
                    </div>
                    <div v-if="$vuetify.breakpoint.xs">
                        <v-icon
                            left
                            class="action-icon"
                            style="color: var(--ll-text-brand)"
                            @click="respond(response)"
                        >
                            reply
                        </v-icon>
                        <v-icon
                            v-if="online"
                            left
                            dark
                            class="material-icons-outlined action-icon"
                            style="color: var(--ll-text-brand)"
                            @click="assign(response)"
                        >
                            assignment_turned_in
                        </v-icon>
                    </div>
                </div>
                <table class="custom-responses-data-table">
                    <tbody>
                        <tr>
                            <td>Status :</td>
                            <td>
                                <span>{{ response.stage === "CT" ? "CLOSED" : "OPEN" }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Locator :</td>
                            <td>
                                <span>{{ locatorName(response.locator) }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Response :</td>
                            <td>
                                <span>
                                    {{
                                        response.response_code !== ""
                                            ? response.response_code
                                            : "(No Response)"
                                    }}
                                </span>
                                <v-btn
                                    v-if="response.excavator_reply_disposition"
                                    text
                                    small
                                    class="ml-4"
                                    elevation="2"
                                    :color="response.excavator_reply_disposition === 'ACCEPTED' ? 'success' : 'danger'"
                                    @click="showExcavatorReplyText(response.excavator_reply_text)"
                                > <v-icon left>mdi-information</v-icon>
                                    {{
                                        response.excavator_reply_disposition !== ""
                                            ? response.excavator_reply_disposition
                                            : ""
                                    }}
                                </v-btn>
                            </td>
                        </tr>
                        <tr v-if="response.epr_error">
                            <td>Response Failed :</td>
                            <td>
                                <span style="color: #FF0000">⚠️ {{ response.epr_error }}</span>
                            </td>
                        </tr>
                        <tr v-if="hasBillingModule">
                            <ResponseBillingCode
                                :response-id="response.rowid"
                                :billing="ticketResponsesBilling"                               
                            />                             
                        </tr>                                               
                        <tr v-show="response.response_code.length !== 0">
                            <td>Response by :</td>
                            <td>
                                <span>
                                    {{ response.response_by !== "" ? response.response_by : "" }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.response_code.length !== 0">
                            <td>+Comment :</td>
                            <td>
                                <span>
                                    {{
                                        response.response_comment !== ""
                                            ? response.response_comment
                                            : ""
                                    }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.response_url">
                            <td>+URL :</td>
                            <td>
                                <span>
                                    {{
                                        response.response_url !== "" ? response.response_url : ""
                                    }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.response_date">
                            <td>Response Date :</td>
                            <td>
                                <span>
                                    {{
                                        response.response_date !== ""
                                            ? formateDate(response.response_date)
                                            : ""
                                    }}
                                </span>
                                ({{ fromNow(response.response_date) }})
                            </td>
                        </tr>
                        <tr v-show="response.date_located">
                            <td>Date Located :</td>
                            <td>
                                <span>
                                    {{
                                        response.date_located !== ""
                                            ? formateDate(response.date_located)
                                            : ""
                                    }}
                                </span>
                                ({{ fromNow(response.date_located) }})
                            </td>
                        </tr>
                        <tr v-show="response.units_marked_count">
                            <td>Units Marked :</td>
                            <td>
                                <span>
                                    {{
                                        response.units_marked_count !== ""
                                            ? response.units_marked_count
                                            : ""
                                    }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.units_worked_count">
                            <td>Time Worked :</td>
                            <td>
                                <span>
                                    {{
                                        response.units_worked_count !== ""
                                            ? formatCurrentUnitsWorked(response.units_worked_count)
                                            : ""
                                    }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.response_code.length !== 0">
                            <td>Work Done :</td>
                            <td>
                                <span>
                                    {{ response.work_done !== "" ? response.work_done : "" }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.excav_note">
                            <td>Note to Excavator :</td>
                            <td>
                                <span>
                                    {{ response.excav_note !== "" ? response.excav_note : "" }}
                                </span>
                            </td>
                        </tr>
                        <tr v-show="response.response_code.length !== 0">
                            <td>In House Comments :</td>
                            <td>
                                <span>
                                    {{ response.remarks !== "" ? response.remarks : "" }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-row>
            <v-row
                v-if="response.offlineResponse"
                class="offline-response-row d-flex flex-column"
            >
                <div class="offline-response-data mx-2 my-2 px-2">
                    <div class="section-title">
                        Offline Response
                    </div>
                    <table class="custom-responses-data-table">
                        <tbody>
                            <tr>
                                <td>Response :</td>
                                <td>
                                    <span>{{
                                        response.offlineResponse.response_code !== ""
                                            ? response.offlineResponse.response_code
                                            : "(No Response)"
                                    }}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="response.offlineResponse.response_by">
                                <td>Response By :</td>
                                <td>
                                    <span>{{ response.offlineResponse.response_by }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Comment :</td>
                                <td>
                                    <span>{{
                                        response.offlineResponse.response_comment || "-"
                                    }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Response Date :</td>
                                <td>
                                    <span>{{
                                        formateDate(response.offlineResponse.response_date)
                                    }}</span>
                                    ({{ fromNow(response.offlineResponse.response_date) }})
                                </td>
                            </tr>
                            <tr>
                                <td>Date Located :</td>
                                <td>
                                    <span>{{
                                        formateDate(response.offlineResponse.date_located)
                                    }}</span>
                                    ({{ fromNow(response.offlineResponse.date_located) }})
                                </td>
                            </tr>
                            <tr>
                                <td>Units Marked :</td>
                                <td>
                                    <span>{{
                                        response.offlineResponse.units_marked || "-"
                                    }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Time Worked :</td>
                                <td>
                                    <span>{{
                                        formatCurrentUnitsWorked(
                                            response.offlineResponse.units_worked
                                        ) || "-"
                                    }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Work Done :</td>
                                <td>
                                    <span>{{ response.offlineResponse.work_done || "-" }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>In House Comment :</td>
                                <td>
                                    <span>{{ response.offlineResponse.remarks || "-" }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-row>
        </v-card>
        <TicketsResponseDialog
            :selected-tickets="currentMemberResponseTicket"
            :show="showTicketsResponseDialog"
            @close-response-dialog="closeRespond"
            @reponse-success="responseSuccess"
            @offline-reponse-success="offlineResponseSuccess"
        />
        <TicketResponseErrorDialog
            :show="showRespondError"
            :respond-result="respondResult"
            @close-response-error-dialog="closeRespondErrorDialog"
        />
        <TicketsAssignDialog
            :selected-tickets="currentMemberResponseTicket"
            :show="showTicketsAssignDialog"
            @close-assign-dialog="closeAssign"
            @assign-success="assignSuccess"
        />
        <v-dialog
            v-model="showExcavatorReply"
            width="auto"
            scrollable
            :fullscreen="this.$vuetify.breakpoint.xsOnly"
        >
            <v-card
                class="mx-auto pa-4"
            >
                <v-card-title>
                    Excavator Reply
                </v-card-title>
                <div>
                    <pre>
                        {{ '\r\n' + excavator_reply_text }}
                    </pre>
                </div>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        outlined
                        color="primary"
                        @click="showExcavatorReply = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import TicketsResponseDialog from '../TicketsResponseDialog.vue';
import TicketsAssignDialog from '../TicketsAssignDialog.vue';
import moment from 'moment';
import TicketResponseErrorDialog from '../ErrorDialogs/TicketRespondErrorDialog.vue';
import { guidEqual } from '@/utils/guid.js';
import { hasPermission } from '../../utils/permissions';
import ResponseBillingCode from './ResponseBilling/ResponseBillingCode.vue';

export default {
    name: 'Responses',
    components: {
        TicketsResponseDialog,
        TicketsAssignDialog,
        TicketResponseErrorDialog,
        ResponseBillingCode       
    },
    props: {
        ticketDetails: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    data: () => ({
        currentRespone: {},
        currentAssignment: {},
        showTicketsResponseDialog: false,
        showTicketsAssignDialog: false,
        respondResult: {},
        showRespondError: false, 
        showExcavatorReply: false,
        excavator_reply_text: '',
    }),
    computed: {
        ticketResponsesBilling: state => state.ticketDetails.Ticket_ResponsesBilling,
        online() {
            return !this.$store.getters.forceOffline;
        },
        offlineResponses() {
            return this.$store.getters.offlineResponses;
        },
        ticketDetailResponses() {
            return this.ticketDetails.Ticket_Responses.map((response) => {
                response.offlineResponse = this.offlineResponses.find(
                    (offlineResponse) => guidEqual(offlineResponse.rowid, response.rowid)
                );
                return response;
            });
        },
        currentMemberResponseTicket() {
            let actionTickets = [];
            let details = this.ticketDetails;
            let actionTicket = Object.assign({}, details.Tickets);
            let ticketStatus = details.Ticket_Status;
            for (let key in ticketStatus) {
                actionTicket['TS_' + key] = ticketStatus[key];
            }
            for (let key in this.currentRespone) {
                actionTicket['TR_' + key] = this.currentRespone[key];
            }
            actionTickets.push(actionTicket);
            return actionTickets;
        }, 
        hasBillingModule() {
            return hasPermission('USE_BILLING_MODULE');
        },   
    },
    methods: {
        respond(response) {
            this.currentRespone = response;
            this.showTicketsResponseDialog = true;
        },
        closeRespondErrorDialog() {
            this.showRespondError = false;
            this.respondResult = {};
        },
        closeRespond() {
            this.showTicketsResponseDialog = false;
        },
        offlineResponseSuccess() {
            this.closeRespond();
            this.$emit('offline-response-success');
        },
        responseSuccess(result) {
            this.updateTicket(result);
            this.closeRespond();
            if (result.errors) {
                this.respondResult = result;
                this.showRespondError = true;
            }
        },
        updateTicket(result) {
            for (let ticket of result.tickets) {
                if (ticket.result.result !== 'OK') {
                    console.error('updateTicket failed with error ', ticket.result);
                }
            }
            this.$emit('update-ticket-details');
        },
        assign(response) {
            this.currentRespone = response;
            this.showTicketsAssignDialog = true;
        },
        closeAssign() {
            this.showTicketsAssignDialog = false;
        },
        assignSuccess(result) {
            this.updateTicket(result);
            this.closeAssign();
        },
        formateDate(date) {
            return moment(date).format('DD MMM YYYY, hh:mm a');
        },
        fromNow(date) {
            return moment(date).fromNow();
        },
        formatCurrentUnitsWorked(unitsWorked) {
            const minutes = unitsWorked % 60;
            const hours = Math.floor(unitsWorked / 60);
            let result = '';
            if (hours) {
                result = hours + 'h';
            }
            if (minutes) {
                if (hours) {
                    result += ' ';
                }
                result += minutes + 'm';
            }
            return result;
        },
        locatorName(uid) {
            const locators = this.$store.getters.companyUsers.filter(
                (user) => user.ingroup === 'Locator'
            );
            let locator = locators.filter(
                (user) => user.uid.toUpperCase() === `{${uid}}`.toUpperCase()
            )[0];
            return locator ? `${locator.account} : ${locator.name.toUpperCase()}` : 'Un-Assigned';
        },
        showExcavatorReplyText(text) {
            this.excavator_reply_text = text || '';
            this.showExcavatorReply = true;
        }
    },
};
</script>

<style>
.responses-container {
  background: var(--ll-surface-warning) !important;
  border-radius: 4px !important;
  padding: 12px 12px 8px !important;
}
.custom-responses-data-table {
  font-size: 12px;
}
.custom-responses-data-table tr {
  display: block;
  height: 20px;
}
.custom-responses-data-table tr td:first-child {
  width: 220px;
}
.custom-responses-data-table tr td:last-child span {
  font-weight: 500;
}
.custom-header {
  margin-top: 12px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: start;
}
.custom-header span {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
}
.custom-header .response-square {
  display: inline-block;
  background-color: #f3a72e;
  height: 12px;
  width: 12px;
  border-radius: 4px;
  margin-right: 7px;
}
.custom-header .action-btn .v-btn__content {
  color: var(--ll-text-brand) !important;
}
.responses-container .offline-response-row {
  background-color: var(--ll-surface-error);
  margin-bottom: -8px;
}
.responses-container .offline-response-data .section-title {
  font-size: 14px;
  font-weight: 700;
}
.custom-responses-data-table tbody tr {
  height: 100%;
}
</style>
